// import useEffect and useState
import { useEffect, useState } from "react";
// import modal from material UI
import { Modal, Box } from "@mui/material";
import { CurrentUser, getDisclaimerDocLink } from "../Service/EndPoints";
import { useAppDispatch } from "../../store/hooks";
import { GetDisclaimerDoc, SaveDisclaimerDocSigned } from "../../store/Machines.store";
import {
  
  IDisclaimerDocSigned as DisclaimerDocSigned,
 
} from "../../interfaces";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export default function DisclaimerDoc({onIsDocSigned,onlyLoad}) {
  const [displayPopUp, setDisplayPopUp] = useState(false);
  const documentURL =getDisclaimerDocLink();
  const dispatch = useAppDispatch();
  
  useEffect(()=>{


    dispatch(
      GetDisclaimerDoc((data: any) => {
        if (
          data.length <1
        ) {
          onIsDocSigned(true);
          setDisplayPopUp(true)
        }
        else{
          onIsDocSigned(true);

        }
      })
    );
  },[dispatch,onIsDocSigned])



  // when pop-up is closed this function triggers
  const closePopUp = (event, reason) => {
    if (reason !== 'backdropClick') {
      localStorage.setItem("seenPopUp", true);
      // setting state to false to not display pop-up
      const objDoc: DisclaimerDocSigned = {
        Name: CurrentUser().customFields["first-name"]+" "+CurrentUser().customFields["last-name"] ,
        Date: new Date().toLocaleString(),
        Email: CurrentUser().auth.email,
        Agreed:"Accepted",
        func:"doc"
       
      };
        dispatch(
          SaveDisclaimerDocSigned(objDoc, function () {
            setDisplayPopUp(false);
          })
        );
      
    
    
    }
  
  };


  return (
    <>
      <div className="">

  {onlyLoad &&    
              
              <iframe

                src={documentURL}
                width="100%"
                height="600px"
                title="test"
                className="shadow-sm "
              />
}
        {/* conditional rendering, if displayPopUp is truthy we will show the modal */}
        {displayPopUp && (
          <Modal
            open={true}
          
            // once pop-up will close "closePopUp" function will be executed
            onClose={closePopUp}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className=" w-full lg:w-2/3 md:w-2/3  container m-auto "
          >
          <>
        
          
            <Box
              sx={style}
              className="w-full bg-white border-[#06B4FF] border-2 shadow-inner"
            >
                  <h2 id="modal-modal-title" className="bold text-[#1D1E22] p-3 shadow-lg">Terms & Condition</h2>
              <iframe
                src={documentURL}
                width="100%"
                height="600px"
                title="test"
                className="shadow-sm"
              />
              <div className=" items-center text-center p-3 w-full float-right hover:cursor-pointer  ">
               
                <div >
                  <button
                    onClick={closePopUp}
                    type="button"
                    className="text-[#E4EFF9] w-52 float-right bg-[#06B4FF] hover:cursor-pointer  h-[48px]"
                  >
                    I Accept
                  </button>
                </div>
              </div>
            </Box>
            </>
          </Modal>
        )}
      </div>
    </>
  );
}
